// extracted by mini-css-extract-plugin
export default {"imageWrapper":"AG-z","twoColumnImage":"BG-z"};